import {
    FETCH_PLAYER_GOLF_STATS,
    FETCH_PLAYER_GOLF_STATS_SUCCESS,
    FETCH_PLAYER_GOLF_STATS_FAIL
} from '../../actions/ActionTypes';

const INITIAL_STATE = {
    isFetching: false,
    initialLoadComplete: false,
    payload: {},
    loadFailed: false
};

const fetchPlayerGolfStatsSuccess = (state, action) => {
    return {
        isFetching: false,
        payload: action.playerGolfStats,
        initialLoadComplete: true
    };
};

const fetchPlayerGolfStatsFail = (state, action) => {
    return {
        isFetching: false,
        payload: action.playerGolfStats,
        initialLoadComplete: true,
        loadFailed: true
    };
};

const handlers = {
    [FETCH_PLAYER_GOLF_STATS_SUCCESS]: fetchPlayerGolfStatsSuccess,
    [FETCH_PLAYER_GOLF_STATS_FAIL]: fetchPlayerGolfStatsFail
};

export default function playerGolfStats(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// Actions
export function fetchPlayerGolfStats(state) {
    return {
        // ...state,
        type: FETCH_PLAYER_GOLF_STATS,
        isFetching: true
    };
}

export const getPlayerGolfStats = (state) => {
    return state.playerGolfStats;
};
